<template>
  <div class="bb-balance-invoices">
        <div class="bb-balance-invoices-table">
          <div class="bb-balance-invoices-table__row bb-table-row_header">
            <div class="bb-balance-invoices-table__cell bb-balance-invoices-table__cell_title">INVOCE</div>
            <div class="bb-balance-invoices-table__cell bb-balance-invoices-table__cell_title">BALANCE, AED</div>
          </div>
          <vue-perfect-scrollbar class="bb-balance-invoices-table__height">
            <div class="bb-balance-invoices-table__row"
                 v-for="(invoice, index) in totalInvoice.items"
                 :key="invoice._id + '' + index">
              <div @click="openBalance(invoice)"
                   class="bb-balance-invoices-table__cell
                          bb-balance-invoices-table__cell_active"
              >
                {{invoice.number}}
              </div>
              <div class="bb-balance-invoices-table__cell
                          bb-balance-invoices-table__cell_end"
              >
                {{convertNumber(invoice.balance)}}
              </div>
            </div>
          </vue-perfect-scrollbar>
          <div class="bb-balance-invoices-table__total">
            {{convertNumber(totalInvoice.balance)}}
          </div>
        </div>
  </div>
</template>

<script>
import convertNumber from '@/mixin/convertNumber'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import SoaApi from '@/api/Soa/api'
export default {
  name: 'TotalInvoice',
  mixins: [convertNumber],
  components: {
    VuePerfectScrollbar
  },
  props: ['soaTotals', 'soaList'],
  data () {
    return {
      totalInvoice: {}
    }
  },
  methods: {
    getTotalInvoices () {
      const query = {
        client: this.$route.params.id
      }
      SoaApi.getTotalInvoice(query)
        .then(({data: {...totalInvoiceData}}) => {
          this.totalInvoice = totalInvoiceData
        })
        .catch((err) => {
          console.error(err)
        })
    },
    openBalance (invoice) {
      this.$emit('openBalance', invoice)
    }
  },
  beforeMount () {
    this.getTotalInvoices()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";

  .bb-balance-invoices {
    &-table {
      display: grid;

      &__height {
        min-height: 42px;
        max-height: calc(80vh - 250px);
        overflow: hidden;
      }

      &__row:first-child {
        border-top: none;
      }

      &__total {
        display: flex;
        justify-content: flex-end;
        padding-right: 15px;
        padding-top: 12px;
        font-weight: bold;
        font-size: 14px;
        line-height: 17px;
        color: $color-accent;
        border-top: 1px solid $color-wild-sand;
      }

      &__row {
        display: grid;
        width: 100%;
        grid-template-columns: 2fr 1fr;
        border-top: 1px solid $color-wild-sand;
        padding: 16px 16px;

        &_header {
          border-top: none;
          padding: 5px;
        }
      }

      &__cell {
        word-break: break-word;
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;

        &_active {
          cursor: pointer;
          transition: .3s;

          &:hover {
            color: $color-accent
          }
        }

        &_end {
          text-align: end;
        }

        &_title {
          color: $color-accent;
          font-weight: 600;
          font-size: 12px;
          line-height: 14px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TotalInvoice.vue